const STATUS_MAP = {
  draft:     { label: 'Draft',     cls: 'badge--draft' },
  submitted: { label: 'Submitted', cls: 'badge--submitted' },
  approved:  { label: 'Approved',  cls: 'badge--approved' },
  rejected:  { label: 'Rejected',  cls: 'badge--rejected' },
  active:    { label: 'Aktif',     cls: 'badge--approved' },
  inactive:  { label: 'Nonaktif',  cls: 'badge--rejected' },
};

const Badge = ({ status }) => {
  const cfg = STATUS_MAP[status] || { label: status, cls: 'badge--draft' };
  return <span className={`badge ${cfg.cls}`}>{cfg.label}</span>;
};

export default Badge;
